import { useState, useEffect } from 'react';
import { useAdvisor } from '@/components/feature/AdvisorProvider';
import { trackContact } from '@/hooks/usePixel';

export default function RequirementsBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { wapp } = useAdvisor();

  useEffect(() => {
    const stored = sessionStorage.getItem('req-banner-dismissed');
    if (stored === 'true') setDismissed(true);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('req-banner-dismissed', 'true');
  };

  if (dismissed) return null;

  return (
    <div className="relative bg-aa-black border-b-2 border-aa-gold/30 overflow-hidden">
      {/* Background pulse effect */}
      <div className="absolute inset-0 bg-gold-radial animate-gold-pulse" />

      {/* Content */}
      <div className="relative w-full px-4 md:px-8 lg:px-12 py-6 md:py-8">
        <div className="max-w-5xl mx-auto">
          {/* Alert Header */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-aa-gold/15 border border-aa-gold/30 flex-shrink-0">
              <i className="ri-alert-fill text-aa-gold text-xl md:text-2xl" />
            </div>
            <div>
              <h2 className="text-aa-gold font-display text-lg md:text-2xl leading-tight">
                Requisitos Indispensables
              </h2>
              <p className="text-aa-gray-400 text-xs md:text-sm">
                Lea atentamente antes de continuar
              </p>
            </div>
          </div>

          {/* Requirements Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-4">
            {/* Requirement 1 - Travel */}
            <div className="flex items-start gap-3 bg-aa-gold/5 border border-aa-gold/10 rounded-lg p-3 md:p-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-aa-gold/10 flex-shrink-0 mt-0.5">
                <i className="ri-plane-line text-aa-gold text-sm" />
              </div>
              <div>
                <h3 className="text-aa-gold font-semibold text-sm md:text-base">
                  Disponibilidad para viajar
                </h3>
                <p className="text-aa-gray-300 text-xs md:text-sm leading-relaxed">
                  Debe tener disponibilidad de tiempo para viajar a <strong className="text-white">Cali, Colombia</strong> para formalizar el contrato y coordinar personalmente el movimiento de los recursos.
                </p>
              </div>
            </div>

            {/* Requirement 2 - Income */}
            <div className="flex items-start gap-3 bg-aa-gold/5 border border-aa-gold/10 rounded-lg p-3 md:p-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-aa-gold/10 flex-shrink-0 mt-0.5">
                <i className="ri-money-dollar-circle-line text-aa-gold text-sm" />
              </div>
              <div>
                <h3 className="text-aa-gold font-semibold text-sm md:text-base">
                  Ingresos mínimos requeridos
                </h3>
                <p className="text-aa-gray-300 text-xs md:text-sm leading-relaxed">
                  Debe contar con ingresos superiores a{" "}
                  <strong className="text-white">USD $1,000</strong> mensuales o{" "}
                  <strong className="text-white">$5,000,000 COP</strong>.
                </p>
              </div>
            </div>

            {/* Requirement 3 - Occupation */}
            <div className="flex items-start gap-3 bg-aa-gold/5 border border-aa-gold/10 rounded-lg p-3 md:p-4 md:col-span-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-aa-gold/10 flex-shrink-0 mt-0.5">
                <i className="ri-briefcase-line text-aa-gold text-sm" />
              </div>
              <div>
                <h3 className="text-aa-gold font-semibold text-sm md:text-base">
                  Ocupación o profesión
                </h3>
                <p className="text-aa-gray-300 text-xs md:text-sm leading-relaxed">
                  El solicitante deberá acreditar una ocupación, profesión o actividad económica que permita soportar el desarrollo del proyecto y el cumplimiento de los procedimientos internos de validación y control financiero.
                </p>
              </div>
            </div>
          </div>

          {/* Acknowledge text */}
          <p className="text-aa-gray-500 text-xs text-center mb-4">
            Estos requisitos son de estricto cumplimiento. Si no los reúne, por favor absténgase de continuar.
          </p>

          {/* Close button */}
          <div className="flex justify-center">
            <a
              href={wapp}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackContact}
              className="flex items-center gap-2 bg-aa-gold/10 border border-aa-gold/30 text-aa-gold hover:bg-aa-gold hover:text-aa-black px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-check-line" />
              Entendido, cumplo con los requisitos
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}